export const directoryMode = [{ mode : true }];